import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { IrisLanguageI } from '@iris/common/models/IrisLanguage';
import { IrisModuleFilterI } from '@iris/common/modules/module-filter/models/IrisModuleFilter';
import { SubscriptionMixin } from '@iris/common/mixins/subscription.mixin';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { Observable } from 'rxjs';
import { SkModalBase } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-module-save-filter-modal',
  styleUrls: ['./module-save-filter-modal.component.scss'],
  templateUrl: './module-save-filter-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IrisModuleSaveFilterModalComponent
  extends SubscriptionMixin(SkModalBase<IrisModuleSaveFilterModalComponent, any>) implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly globalSandbox = inject(IrisGlobalSandbox);
  readonly data = inject<{
    userFilter: Partial<IrisModuleFilterI>;
  }>(MAT_DIALOG_DATA);

  set userFilter(userFilter: Partial<IrisModuleFilterI>) {
    this._userFilter = Object.assign({ }, userFilter);
    this.translationsName = userFilter?.translations?.name || { };
    this.userFilterForm.patchValue(this._userFilter, { emitEvent: false });
  }

  get userFilter(): Partial<IrisModuleFilterI> {
    return this._userFilter;
  }

  @Output() filterSave = new EventEmitter<Partial<IrisModuleFilterI>>();

  translationsName = { };
  languages$: Observable<IrisLanguageI[]> = this.globalSandbox.languages$;
  _userFilter: Partial<IrisModuleFilterI> = { } as IrisModuleFilterI;

  private readonly defaultControlValues = {
    name: ['', Validators.required],
    isPublic: false,
    isPinnedByDefault: false,
  };

  readonly userFilterForm = this.formBuilder.group(this.defaultControlValues);

  constructor() {
    super();

    this.userFilter = this.data.userFilter ?? {};
  }

  ngOnInit(): void {
    this.subscribe(
      this.userFilterForm.get('isPublic').valueChanges.pipe(
        filter((isPublic) => !isPublic),
      ),
      () => this.userFilterForm.patchValue({ isPinnedByDefault: false }),
    );
  }

  onFilterSave(): void {
    const translations = {
      translations: {
        name: this.translationsName,
      },
    };

    if (this.userFilter.isPublic) {
      this.userFilter.isPinned ||= this.userFilter.isPinnedByDefault;
    }

    const resultFilter = Object.assign({ }, this.userFilter, this.userFilterForm.value, translations);
    this.closeWithResult(resultFilter);
  }
}
